import { render, staticRenderFns } from "./DashboardV2Performance.vue?vue&type=template&id=09692ea6&scoped=true&"
import script from "./DashboardV2Performance.vue?vue&type=script&lang=js&"
export * from "./DashboardV2Performance.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV2Performance.vue?vue&type=style&index=0&id=09692ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09692ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VDataTable,VIcon})
